import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import './styles.css';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
